'use client';

// Next.js route-level error boundary — reports then shows recovery UI.

import { useEffect } from 'react';
import Link from 'next/link';
import { brandButtonClass, brandTextLinkClass } from '@/components/brand/BrandButton';
import {
  EVENTS,
  captureException,
  safeErrorMessage,
  track,
} from '@/lib/analytics';

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    const message = safeErrorMessage(error);
    track(EVENTS.client_error, {
      message,
      source: 'error.tsx',
      digest: error.digest,
    });
    captureException(error, { source: 'error.tsx', digest: error.digest });
  }, [error]);

  return (
    <div className="ss-page flex min-h-screen flex-col items-center justify-center gap-5 px-6 text-center">
      <div className="max-w-sm space-y-2">
        <h1 className="ss-body font-semibold">Something went wrong</h1>
        <p className="ss-small text-ss-slate">
          This page hit an unexpected error. Try again or return home.
        </p>
      </div>
      <div className="flex items-center gap-3">
        <button
          type="button"
          onClick={reset}
          className={brandButtonClass({ variant: 'secondary', size: 'md' })}
        >
          Try again
        </button>
        <Link href="/" className={brandTextLinkClass}>
          Back to home
        </Link>
      </div>
    </div>
  );
}
